import { Component, inject, input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AnalyticsEvent, AnalyticsService } from '../../services/analytics';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ParamsMeta, ParamsObj, ParamsOptions } from './types';
import { WindowRefService } from '../share/services/window-ref.service';

@Component({
  imports: [CommonModule, ReactiveFormsModule, NzButtonModule],
  selector: 'ava-account-email-sync',
  standalone: true,
  template: `
    <div style="padding-bottom: 10px">
      <div style="font-weight: 400; color: #d43f3a">! Our records indicate you have two email addresses on file.</div>
      <div>Please select the email address for your membership account, website login and email communications.</div>
    </div>

    @if (form) {
      <form [formGroup]="form">
        @for (option of options!.options; track option) {
          <div
            style="font-weight: 400; padding-bottom: 5px; display: grid; gap: 8px; grid-template-columns: min-content auto; align-items: center"
          >
            <input type="radio" name="email" formControlName="email" [id]="option.value" [value]="option.token" />
            <label [for]="option.value">
              {{ option.value }}
            </label>
          </div>
        }

        <div>
          <button
            nz-button
            nzType="primary"
            type="submit"
            [disabled]="form!.pristine"
            [nzLoading]="submitted"
            (click)="onSubmit(form!.value.email); $event.preventDefault()"
          >
            Submit
          </button>
        </div>
      </form>
    }
  `,
})
export class AccountEmailSyncComponent implements OnInit {
  private http = inject(HttpClient);
  analyticsService = inject(AnalyticsService);
  formBuilder = inject(FormBuilder);
  windowRef = inject(WindowRefService);
  document = inject(DOCUMENT);

  params = input('');

  paramsObj: ParamsObj | undefined;
  meta: ParamsMeta | undefined;
  options: ParamsOptions | undefined;
  form = this.formBuilder.group({
    email: ['', Validators.required],
  });
  submitted = false;

  ngOnInit(): void {
    console.log(this.params());
    this.paramsObj = JSON.parse(this.params());
    this.meta = this.paramsObj?.meta;
    this.options = this.paramsObj?.options;

    const event: AnalyticsEvent = {
      eventCategory: 'email_preference',
      eventAction: 'shown',
      eventLabel: 'multi_email_on_file',
      eventValue: 1,
    };
    this.analyticsService.sendEvent(event);

    const eventCustomElement: AnalyticsEvent = {
      eventCategory: 'Custom Element',
      eventAction: 'Supported',
      eventLabel: '<ava-account-email-sync>' + this.windowRef.nativeWindow.location.origin.toLowerCase(),
      eventValue: 1,
    };
    this.analyticsService.sendEvent(eventCustomElement);
  }

  async onSubmit(option: string): Promise<void> {
    if (this.submitted) return;
    this.submitted = true;

    const event: AnalyticsEvent = {
      eventCategory: 'email_preference',
      eventAction: 'selected',
      eventLabel: 'multi_email_on_file',
      eventValue: 1,
    };
    this.analyticsService.sendEvent(event);

    const headers = new HttpHeaders({});
    try {
      await this.http
        .request('POST', this.options?.callBack + option, {
          headers: headers,
        })
        .toPromise();
      // console.log('reloading')
      this.document.location.href = this.options?.returnPath.toLowerCase() || '';
    } catch (e) {
      this.submitted = false;
    }
  }
}
